import React from 'react';

const RazemLogo = ({homepageUrl}: { homepageUrl: string }) => (
  <a href={homepageUrl} className="razem-logo">
    <img
      src="/assets/images/razem-logo.png"
      width="128"
      height="128"
      loading="eager"
      alt="Logo Partii Razem - fioletowy prostokąt z napisem RAZEM dużymi literami"
    />
  </a>
);

RazemLogo.propTypes = {};
RazemLogo.defaultProps = {};

export default RazemLogo;
